"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CoreContext_1 = __importDefault(require("./CoreContext"));
var createTransport_1 = __importDefault(require("./createTransport"));
var Error_1 = __importDefault(require("./Error"));
var transport = (0, createTransport_1.default)();
var Core = function (props) {
    var initialized = (0, react_1.useRef)(false);
    var _a = (0, react_1.useState)(false), ready = _a[0], setReady = _a[1];
    var _b = (0, react_1.useState)(), error = _b[0], setError = _b[1];
    var stateListeners = (0, react_1.useRef)([]);
    var eventListeners = (0, react_1.useRef)([]);
    var errorListeners = (0, react_1.useRef)([]);
    var on = function (name, listener) {
        if (name === 'state')
            stateListeners.current = __spreadArray(__spreadArray([], stateListeners.current, true), [listener], false);
        if (name === 'event')
            eventListeners.current = __spreadArray(__spreadArray([], eventListeners.current, true), [listener], false);
        if (name === 'error')
            errorListeners.current = __spreadArray(__spreadArray([], errorListeners.current, true), [listener], false);
    };
    var off = function (name, listener) {
        if (name === 'state')
            stateListeners.current = stateListeners.current.filter(function (l) { return l !== listener; });
        if (name === 'event')
            eventListeners.current = eventListeners.current.filter(function (l) { return l !== listener; });
        if (name === 'error')
            errorListeners.current = errorListeners.current.filter(function (l) { return l !== listener; });
    };
    (0, react_1.useEffect)(function () {
        if (initialized.current)
            return;
        initialized.current = true;
        var onCoreEvent = function (_a) {
            var name = _a.name, args = _a.args;
            switch (name) {
                case 'NewState':
                    stateListeners.current.forEach(function (listener) { return listener(args); });
                    break;
                case 'CoreEvent': {
                    switch (args.event) {
                        case 'Error': {
                            var _b = args.args, source_1 = _b.source, error_1 = _b.error;
                            errorListeners.current.forEach(function (listener) { return listener(source_1, error_1); });
                            break;
                        }
                        default:
                            eventListeners.current.forEach(function (listener) { return listener(args.event, args.args); });
                            break;
                    }
                    break;
                }
                default:
                    break;
            }
        };
        transport
            .init(props.appInfo)
            .then(function () {
            window.core = transport;
            window.onCoreEvent = onCoreEvent;
            setReady(true);
            setError(null);
        })
            .catch(function (e) {
            console.error('Failed to initialize core:', e);
            setReady(false);
            setError(e);
        });
        return function () {
            stateListeners.current = [];
            eventListeners.current = [];
            errorListeners.current = [];
        };
    }, []);
    return (react_1.default.createElement(CoreContext_1.default.Provider, { value: { transport: transport, on: on, off: off } },
        error && !ready && react_1.default.createElement(Error_1.default, { message: error.message }),
        ready && !error && props.children));
};
exports.default = Core;
